/* eslint-disable no-param-reassign */
import { DRL_COMPOUNDING_ALIAS, DRL_COMPOUNDING_PERIODS_ALIAS } from 'common/constants/cap-table';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { getStringValue, removeClassName, removeValidationClasses } from 'utilities';
import { TCells } from '../../../../../ValuationsAllocation/approaches/DiscountCashFlow/components/EffectiveTaxRateLedger/types';
import { extractColumnLetterSet } from '../../../utilities/variablePropertiesUtils';

const findCellForColumnByAlias = (currentCell: ICell, cells: TCells, aliasToFind: string): ICell | null => {
  const currentCellLetter = extractColumnLetterSet(currentCell.key!);
  if (!currentCellLetter) {
    return null;
  }
  const desiredCell = Object.values(cells).find((cell: ICell) => {
    const tempCellColumn = extractColumnLetterSet(cell.key!);
    const isSameColumn = tempCellColumn?.startsWith(currentCellLetter);
    const isDesiredCellForColumn = isSameColumn && cell.alias === aliasToFind;
    return isDesiredCellForColumn;
  });
  if (!desiredCell) {
    return null;
  }

  return desiredCell;
};

const conditions = ({
  cell,
  cells,
  tableData,
}: {
  cell: ICell;
  cells: { [key: string]: TCells };
  tableData: { isDisabled: boolean };
  onCellsChanged: (cellChanges: { cell: ICell; value: any }[]) => void;
}) => {
  const { isDisabled } = tableData;

  const { DividendRateLedger } = cells;
  const { alias, className } = cell;

  const getCellValue = (tempCell: ICell) =>
    tempCell.defaultValue && !Number.isNaN(tempCell.defaultValue)
      ? Number(tempCell.defaultValue)
      : tempCell.defaultValue ?? '';

  const resetCellConfig = (originalCell: ICell) => {
    Object.assign(originalCell, {
      hidden: true,
      readOnly: true,
      forceComponent: false,
      disableEvents: false,
      component: null,
      dialog: null,
      greaterThan: null,
      isDisabled,
    });
  };
  const setAsEditable = (originalCell: ICell) => {
    resetCellConfig(originalCell);
    Object.assign(originalCell, {
      readOnly: isDisabled,
      hidden: false,
    });
  };

  const setAsHidden = (originalCell: ICell, keepValue = false) => {
    resetCellConfig(originalCell);
    if (!keepValue) {
      Object.assign(originalCell, {
        value: getCellValue(originalCell),
        expr: getCellValue(originalCell),
      });
    }

    Object.assign(originalCell, {
      hidden: true,
      tooltipMessages: null,
      isRequired: false,
      className: removeClassName(removeValidationClasses(getStringValue(className)), 'read-only--white'),
    });
  };

  if (alias === DRL_COMPOUNDING_ALIAS) {
    const isCompounding = Boolean(Number(cell.value));
    const compoundingPeriodCell = findCellForColumnByAlias(cell, DividendRateLedger, DRL_COMPOUNDING_PERIODS_ALIAS);

    if (isCompounding && compoundingPeriodCell) {
      setAsEditable(compoundingPeriodCell);
    } else if (compoundingPeriodCell) {
      setAsHidden(compoundingPeriodCell);
    }
  }

  return cell;
};

export default conditions;
